import { z } from "zod";

/**
 * The page a question was asked from, when it is not JuisciGPT itself: the
 * Quick task composer floating over Explore. It rides the hand-off (landing,
 * then conversation) as router state, so the conversation's breadcrumb and Back
 * lead to that page instead of the JuisciGPT landing. Router state only: a
 * deep link, or a browser that drops it on reload (iOS Safari), opens the
 * conversation as JuisciGPT's own.
 */
export const askedFromSchema = z
  .object({
    kind: z.literal("explore"),
    // Path and query of the feed, so Back returns to the same filter.
    path: z.string().startsWith("/"),
  })
  .nullable()
  .default(null);

export type AskedFrom = z.infer<typeof askedFromSchema>;
